import React from 'react';

import { IndeterminateProgressBar } from './IndeterminateProgressBar'
export const LoadingScreen = () => (
  <div className="loading-screen" style={{flexDirection: 'column', alignItems: 'center'}}>
    <IndeterminateProgressBar /> 
  </div>
)